import React from 'react';
import _ from 'lodash';
import Workbook from 'vendor/react-excel-workbook';
import {calculateProgramArea} from 'common/utils';

export const getExportData = (taskData) => {
  let exportData = _.map(taskData, (task) => {
    let pocJson = _.get(JSON.parse(task.pocJson || '[]'), 0);
    const {programId, grantId, fundingStreamsJson} = task;
    let regionalApplicant = _.get(task, 'regionalApplicant', 'No');
    regionalApplicant = regionalApplicant === null ? 'No' : regionalApplicant;
    return {
      ...task,
      programArea: calculateProgramArea(programId, grantId, fundingStreamsJson),
      regionalApplicant: regionalApplicant,
      ...pocJson,
    };
  });
  return exportData;
};

export const CourtesyWorkBook = ({exportRef, taskData}) => {
  const exportData = getExportData(taskData);

  return (
    <Workbook filename="CourtesyNotification.xlsx" element={<span ref={exportRef} />}>
      <Workbook.Sheet data={exportData} name="Dashboard Sheet">
        <Workbook.Column label="Fiscal Year" value="fiscalYear" />
        <Workbook.Column label="Round" value="courtesyGroupName" />
        <Workbook.Column label="Award State" value="organizationState" />
        <Workbook.Column label="Program ID" value="programId" />
        <Workbook.Column label="Award Number" value="grantId" />
        <Workbook.Column label="Organization Name" value="organizationName" />
        <Workbook.Column label="Program Area" value="programArea" />
        <Workbook.Column label="Regional Request" value="regionalApplicant" />
        <Workbook.Column label="Applicant Type" value="applicantType" />
        <Workbook.Column label="Federal Share" value="fedShare" />
        <Workbook.Column label="POC First Name" value="firstName" />
        <Workbook.Column label="POC Last Name" value="lastName" />
        <Workbook.Column label="POC Phone" value="phoneNumber" />
        <Workbook.Column label="POC Extension" value="extension" />
        <Workbook.Column label="City" value="organizationCity" />
        <Workbook.Column
          label="Zipcode+4"
          value={(row) =>
            row.organizationZipExt
              ? `${row.organizationZip}-${row.organizationZipExt}`
              : row.organizationZip
          }
        />
      </Workbook.Sheet>
    </Workbook>
  );
};

export default CourtesyWorkBook;
